<template>
    <v-card>
        <v-toolbar
                color="#00CE81"
                height="45px"
                class="toolbar"
                elevation="0"
        >گزارش گیری
        </v-toolbar>
        <v-card-text>
            <div class="content-dialog parent-desire-time"  style="height: 230px;display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
              <div v-if="superUser" class="tab">
                <div :class="!adminLevel ? 'activeTab' : 'disActiveTab'" @click="changeLevel('user')">
                  <p>شحصی</p>
                </div>
                <div :class="adminLevel ? 'activeTab' : 'disActiveTab'" @click="changeLevel('admin')">
                  <p>مدیریتی</p>
                </div>

              </div>
                <div class="start-date">
                    <div  class="calendar">
                        <v-chip
                                class="form-control form-control-lg time-chip"
                                :color="startBackground" :text-color="startColor" :ripple="false"
                                v-bind:class="[dateStartDialog==='' ? disActiveTarikh : activeTarikh]"
                                type="text"
                                id="dialog-tarikh-start-mobile"
                                placeholder="تاریخ"
                                @click="showStartCalendarDialog=true"
                                v-text="dateStartFarsiDialog===''?'از تاریخ':dateStartFarsiDialog"
                        ></v-chip>
                        <date-picker
                                convert-numbers
                                :show-now-btn="true"
                                label="تاریخ"
                                color="#00CE81"
                                v-model="dateStartDialog"
                                format="jYYYY/jMM/jDD"
                                element="dialog-tarikh-start-mobile"
                                clearable
                                :editable="true"
                                :max="dateEndDialog === '' ? nowTime : dateEndDialog"
                                :show="showStartCalendarDialog"
                                @close="dateStartPicker()">
                        </date-picker>
                    </div>

                </div>
                <div class="end-date">
                    <div  class="calendar">
                        <v-chip
                                class="form-control form-control-lg time-chip"
                                :color="endBackground" :text-color="endColor" :ripple="false"
                                v-bind:class="[dateEndDialog==='' ? endDisActiveTarikh : endActiveTarikh]"
                                type="text"
                                id="dialog-tarikh-mobile"
                                placeholder="تاریخ"
                                @click="showEndCalendarDialog=true"
                                v-text="dateEndFarsiDialog===''?'تا تاریخ':dateEndFarsiDialog"
                        ></v-chip>
                        <date-picker
                                convert-numbers
                                color="#00CE81"
                                v-model="dateEndDialog"
                                format="jYYYY/jMM/jDD"
                                element="dialog-tarikh-mobile"
                                clearable
                                :editable="true"
                                :min="dateStartDialog"
                                :show="showEndCalendarDialog"
                                @close="dateEndPicker()">
                        </date-picker>
                    </div>
                </div>
                <div v-if="adminLevel">
                    <v-select
                            :items="users"
                            v-model="userSelector"
                            item-text="name"
                            item-value="id"
                            v-bind:class="[userSelector.length===0 ? disActiveUser : activeUser]"
                            placeholder="افراد"
                            dense
                            rounded
                            color="#00CE81"
                            item-color="green"
                            hide-details
                            multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <div style="display: flex">
                                <div v-if="index === 0">
                                    <span>يك نفر</span>
                                </div>
                                <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                >
                                  (+{{ userSelector.length - 1 }})
                                 </span>
                            </div>
                        </template>

                    </v-select>
                </div>
<!--              -->
                <div v-if="!adminLevel">
                    <v-select
                            :items="project"
                            v-model="projectSelector"
                            v-bind:class="[projectSelector.length===0 ? disActiveProject : activeProject]"
                            placeholder="پروژه"
                            dense
                            rounded
                            color="#00CE81"
                            item-color="green"
                            hide-details
                            multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <div style="display: flex">
                                <div v-if="index === 0">
                                    <span>{{ item }}</span>
                                </div>
                                <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                >
                                  (+{{ projectSelector.length - 1 }})
                                 </span>
                            </div>
                        </template>

                    </v-select>
                </div>

            </div>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn
                   :loading="createExcelLoading"
                   @click="createExcell"
                   :disabled="!((dateStartDialog!==''&& dateEndDialog!=='')|| projectSelector.length!==0)"
                   v-bind:class="[(dateStartDialog!=='' && dateEndDialog!=='') || projectSelector.length!==0  ? activeButton : disActiveButton]"
                   :ripple="false"
                   class="button-card"
                   text>خروجی اکسل</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
    import {toFarsiDate} from "../../plugins/toFarsiDate";
    import {getNowTimes} from "../../plugins/getSpecialTimes";
    import {getUtcTime} from "../../plugins/getUtcTime";
    import {getReportForAdmin} from "../../api/fileReport";
    import VuePersianDatetimePicker from "vue-persian-datetime-picker";
    import {mapActions,mapGetters} from "vuex";
    export default {
        name: "gozareshGiri",
        props:{
            projectList:Array,
            dialog:Boolean,
            superUser: {
              default: false,
              type: Boolean
            }
        },
        components:{
            datePicker: VuePersianDatetimePicker
        },
        data:()=>({
            adminLevel: true,
            createExcelLoading:false,
            startBackground:'inherit',
            endBackground:'inherit',
            startColor:'#BBBBBB',
            endColor:'#BBBBBB',
            showStartCalendarDialog:false,
            showEndCalendarDialog:false,
            dateStartDialog:'',
            dateEndDialog:'',
            startDate:'',
            endDate:'',
            activeTarikh:'active-date',
            disActiveTarikh:'dis-active-date',
            endActiveTarikh:'end-active-date',
            endDisActiveTarikh:'dis-end-active-date',
            activeButton:'active-button',
            disActiveButton:'dis-active-button',
            nowTime:'',
            dateStartFarsiDialog:'',
            dateEndFarsiDialog:'',
            project:[],
            users:[],
            projectSelector:[],
            userSelector:[],
            activeProject:'active-project',
            activeUser:'active-project',
            disActiveProject:'dis-active-project',
            disActiveUser:'dis-active-project',
        }),
        methods:{
            ...mapActions({
                getExcelReportReq:'fileReport/fetchFileReport',
                printAlert:'alert/printAlert',
                fetchUsersList: 'user/fetchUsersList'

            }),
          changeLevel(input){
              if (input === 'user'){
                this.adminLevel = false
              }
              else {
                this.adminLevel = true
              }
          },
          updateTime(k) {
            if (k < 10) {
              return "0" + k;
            }
            else {
              return k;
            }
          },
            dateStartPicker() {
                this.showStartCalendarDialog = false
                if(this.dateStartDialog!=='') {
                    this.dateStartFarsiDialog = toFarsiDate(this.dateStartDialog)
                }
            },
            dateEndPicker() {
                this.showEndCalendarDialog = false
                if(this.dateEndDialog!=='') {
                    this.dateEndFarsiDialog = toFarsiDate(this.dateEndDialog)
                }
            },
            persianDateToEnglish(date){
                var moment = require('jalali-moment');
                return  moment.from(date, 'fa', 'YYYY-MM-DD').locale('en').format('YYYY-MM-DD');
            },
            async  createExcell() {
                this.createExcelLoading =true
                let startDate = ''
                let endDate = ''
                let params = {}
                let idPojects=[]
                let idUsers=[]
                let date  = new Date()
                let timezoneOffset =date.getTimezoneOffset()
                this.projectSelector.forEach((project)=>{
                    const result = this.projectList.find( ({ name }) => name === project );
                    idPojects.push(result.id)
                })
                startDate = this.persianDateToEnglish(this.dateStartDialog)
                endDate = this.persianDateToEnglish(this.dateEndDialog)


              if (this.adminLevel){
                if (this.userSelector.length!==0){
                  this.userSelector.forEach((userId)=>{
                    const result = this.users.find( ({ id }) => id === userId );
                    idUsers.push(result.id)
                  })
                }
                else idUsers = []

                params = {
                  from_date: startDate,
                  to_date:endDate,
                  list_user_id: idUsers,
                  timezone_offset:timezoneOffset
                }
                try{
                  await getReportForAdmin(params)
                }catch (e) {
                  //
                }


              }
              else
                {
                  console.log('uuuuuu');
                  startDate = getUtcTime(startDate,"00:00:00")
                  endDate = getUtcTime(endDate,"23:59:59")

                  let list_project_id = []
                  if (this.projectSelector.length!==0){
                    list_project_id = idPojects
                  }

                  params = {
                    from_datetime: startDate,
                    till_datetime:endDate,
                    projects_id: list_project_id,
                    timezone_offset:timezoneOffset
                  }
                  try {
                    await this.getExcelReportReq(params)

                    // setTimeout(()=>{
                    //
                    //     fileDownload(this.originalExcel, 'report.xlsx');
                    // },1)

                  }catch (e) {
                    //
                  }
              }



               this.createExcelLoading=false
            },
        },
        computed:{
          ...mapGetters({
            originUsers: 'user/getUsers',
            originalExcel:'fileReport/get_FileReport'
          }),
        },
        async mounted() {
            if (!this.superUser){
              this.adminLevel = false
            }
            else {
              await this.fetchUsersList({page_size: -1})
              let res = this.originUsers.data
              res.forEach((user)=>{
                this.users.push({
                  name: user.first_name+ ' ' + user.last_name,
                  id: user.id
                })
              })
            }
            this.nowTime = getNowTimes();
            this.projectList.forEach((project)=>{
                this.project.push(project.name)
            })
        }
    }
</script>
<style>
    .v-input__slot{
        height: inherit;
    }
</style>
<style scoped>
    .toolbar{
        color: white !important;
        font-size: 1rem;
        font-family: iranYekan;
    }
    .calendar{
        font-family: iranYekan;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .active-date{
        border-radius: 16px;
        border:1px solid #00CE81 !important; ;
        width: 150px;
        padding: 10px;
        height: 35px;
        font-size: 0.875rem;
        font-weight: normal;
        font-family: iranYekan;
        color: #5A5A5A !important;
        background-color: inherit !important;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .dis-active-date{
        border-radius: 16px;
        border:1px solid #BBBBBB !important;
        width: 150px;
        padding: 10px;
        height: 35px;
        background-color:  inherit !important;
        font-size: 0.75rem;
        font-weight: normal;
        font-family: iranYekan;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .dis-end-active-date{
        border-radius: 16px;
        border:1px solid #BBBBBB !important;
        width: 150px;
        padding: 10px;
        height: 35px;
        background-color:  inherit !important;
        font-size: 0.75rem;
        font-weight: normal;
        font-family: iranYekan;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .end-active-date{
        border-radius: 16px;
        border:1px solid #00CE81 !important; ;
        width: 150px;
        padding: 10px;
        height: 35px;
        font-size: 0.875rem;
        font-weight: normal;
        font-family: iranYekan;
        color: #5A5A5A !important;
        background-color: inherit !important;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .active-button{
        border:2px solid #00CE81 !important; ;
        background-color: white;
        color: #00CE81 !important;
        font-weight: normal;
        font-family: iranYekan;
        font-size: 1rem;
        margin-bottom: 1rem;
    }
    .dis-active-button{
        border:1px solid ;
        color:  #707070 !important;
        font-weight: normal;
        font-family: iranYekan;
        font-size: 1rem;
        margin-bottom: 1rem;
    }
    .active-project{
        border:1px solid #00CE81 ;
        height: 33px;
        width: 150px;
        font-family: iranYekan;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .dis-active-project{
        border:1px solid #707070;
        width: 150px;
        height: 35px;
        font-family: iranYekan;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .calendar input::placeholder{
        color: #BBBBBB;
    }
    textarea:focus, input:focus{
        outline: none;
    }
    .parent-desire-time >>> .v-text-field__slot input {
        color: #00CE81;
    }
    .button-card{
        font-family: iranYekan;
        font-size: 14px !important;
        color: #00CE81 !important;
        font-weight: normal;

    }
    .activeTab{
      background-color: #00CE81;
      color: white;
    }
    .disActiveTab{
      background-color: #D9D9D9;
    }
    .tab{
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .tab:hover{
      cursor: pointer;
    }
    .tab p{
      padding: 8px;
      margin: 0;
    }
</style>
